/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setAds } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { sendMessage } from '@insticator/insticator-ui'; // iui-state
// component
import InContentPlacement from 'pages/dashboard/embeds/management/ads/placement/incontent/incontent_placement';



/* ========== ~~~~~~~~~~ EMBED ADs IN CONTENT PLACEMENT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    embedStatus: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData
});

// map actions
const mapDispatchToProps = dispatch => ({
    setAds: (ad1, ad2, overlay) => dispatch(setAds(ad1, ad2, overlay)),
    sendMessage: message => dispatch(sendMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InContentPlacement);
